import {
  productEventEmitter,
  ProductEventPayload,
} from "@made-people/grease-product";
import { useEffect } from "react";
import {
  gtmProductCategory,
  gtmProductImage,
  gtmProductParentId,
  gtmGetListId,
} from "../mm-gtm-helpers";
import { useMmGtm } from "../mm-gtm-context";

export const MmGtmEventSelectItem = () => {
  const { pusher } = useMmGtm();

  useEffect(() => {
    const handleProductClicked = (
      params: ProductEventPayload["productClicked"],
    ) => {
      pusher({
        event: "productClick",
        ecommerce: {
          click: {
            actionField: {
              list: gtmGetListId(params.context),
            },
            products: [
              {
                name: gtmProductParentId(params.productData.base),
                id: params.productData.base.productKey,
                parentId: gtmProductParentId(params.productData.base),
                price: params.productData.purchaseInfo.priceInfo.price.number,
                brand: params.productData.base.content.brand,
                category: gtmProductCategory(params.productData.base),

                // TODO: cannot push this without knowing if it's a bundle or not
                // variant: gtmReturnVariantSku(
                //   params.productData.base.productKey,
                //   params.productData,
                // ),

                position:
                  params.context.type === "plp"
                    ? params.context.position
                    : undefined,
                image: gtmProductImage(params.productData.base),
              },
            ],
          },
        },
      });
    };

    productEventEmitter.on("productClicked", handleProductClicked);
    return () => {
      productEventEmitter.off("productClicked", handleProductClicked);
    };
  }, []);

  return null;
};
